import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UnauthorizedNotificationService } from '../services/unauthorized.notification.service';
import { LogManager } from '../../log/services/log.manager';
import { LogCat } from '../../log/services/log.manager.categories';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(private notificationService: UnauthorizedNotificationService) {}

  CUSTOM_UNAUTHORIZED_CODE = 430;

  /**
   * Intercepts HTTP requests and handles unauthorized access errors.
   * If a request fails with a 430 status (custom code for missing permissions), it logs the error and shows a notification.
   * @param req - The outgoing HTTP request.
   * @param next - The next handler in the chain.
   * @returns An observable of the HTTP event or an error.
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === this.CUSTOM_UNAUTHORIZED_CODE) {
          // Log the missing permission or unauthorized access
          LogManager.error(LogCat.Comm.Proxies, `Unauthorized access: ${error.status} - ${error.message}`, error);
          // Show notification in the UI, passing the error URL if available
          this.notificationService.showUnauthorized(error.url);
        }
        return throwError(error);
        
      })
    );
  }
}
